import React, {useState} from 'react';
import { connect } from "react-redux";
import {
    CardBody,
    Col, Form, FormGroup, Label, Row,
} from 'reactstrap';
import Switch from "react-bootstrap-switch";
import {
    ButtonClean,
    ButtonSearch,
} from "../../../components/buttons/buttonsActions";
import {FL_STATUS} from "../../../components/i18n/formLabels";
import {setFilter} from "../../../redux/actions/generalActions/listActions";
import {useForm} from "react-hook-form";


const TypeAudienceFilter = (props) => {
    const { filter } = props.listProps
    const { app } = props.mainProps

    const fbDataBaseId = app?.fbDataBase?.id

    const [status, setStatus] = useState(filter?.item?.status || null)

    const { handleSubmit } = useForm({
    });

    const cleanFields = () => {
        const tmpFilter = JSON.parse(JSON.stringify(filter))
        if(tmpFilter && tmpFilter.item){
            delete tmpFilter.item.status;
        }
        props.setFilter(tmpFilter);
        setStatus(null)
    }

    const onSubmit = (data, _) => {
        if(!fbDataBaseId)
            return

        const dataFilter = {
            fbDataBase : {  id : fbDataBaseId },
            item : {
                status: status
            }
        }

        props.setFilter(dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="4" className="d-flex align-items-center">
                        <div >
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(TypeAudienceFilter)